module.exports = __webpack_public_path__ + "img/pin-dark.f404e610.png";